export function calcRange(data, field, margin=0.00005) {
  return [
    Math.min(
      ...data.map((person) => person[field])
    ) - margin,
    Math.max(
      ...data.map((person) => person[field])
    ) + margin
  ]
}

function commafy( num ) {
  var str = num.toString().split('.');
  if (str[0].length >= 5) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  if (str[1] && str[1].length >= 5) {
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}